<title>{{ connectingToNdcPage.htmlTitle }}</title>
<app-banner [banner]="connectingToNdcPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="connectingToNdcPage.sections"></app-border-section>
</div>
